module.exports = __webpack_public_path__ + "img/emotion.d6aa7634.svg";